/*
 * STDE Cart Drawer
 * Hoort bij sections/stde-cart-drawer.liquid
 *
 * - Vangt add-to-cart formulieren af en voegt toe via AJAX (geen redirect naar /cart)
 * - Opent de drawer bij toevoegen en bij klik op het cart-icoon
 * - Aantal wijzigen / verwijderen via /cart/change.js + Section Rendering API
 * - Countdown timer in de balk
 */
(function () {
  'use strict';

  var ROOT_ID = 'StdeCart';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function root() { return document.getElementById(ROOT_ID); }
  if (!root()) return; // sectie uitgeschakeld -> theme cart blijft werken

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var themeRoutes = (window.theme && window.theme.routes) || {};
  var URL_ADD = themeRoutes.cartAdd || shopRoot + 'cart/add.js';
  var URL_CHANGE = themeRoutes.cartChange || shopRoot + 'cart/change.js';

  var lastFocus = null;
  var busy = false;

  function sectionId() {
    var r = root();
    return (r && r.getAttribute('data-section')) || 'stde-cart-drawer';
  }

  function onCartPage() {
    return document.body.classList.contains('template-cart');
  }

  /* ---------------- Open / dicht ---------------- */

  function isOpen() {
    var r = root();
    return !!(r && r.classList.contains('is-open'));
  }

  function open() {
    var r = root();
    if (!r) return;
    if (!isOpen()) lastFocus = document.activeElement;
    r.classList.add('is-open');
    r.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('stde-cart-lock');
    var panel = r.querySelector('.stde-cart__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }

  function close() {
    var r = root();
    if (!r || !isOpen()) return;
    r.classList.remove('is-open');
    r.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('stde-cart-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  /* ---------------- Renderen ---------------- */

  function updateBubble(count) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (n) {
      n.textContent = count;
    });
  }

  function render(html) {
    var r = root();
    if (!html || !r) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-stde-body]');
    var current = r.querySelector('[data-stde-body]');
    if (!fresh || !current) return;

    var scroller = current.querySelector('[data-stde-scroll]');
    var scrollTop = scroller ? scroller.scrollTop : 0;

    current.replaceWith(fresh);

    var newScroller = fresh.querySelector('[data-stde-scroll]');
    if (newScroller) newScroller.scrollTop = scrollTop;

    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    var wasEmpty = r.classList.contains('is-empty');
    r.classList.toggle('is-empty', count === 0);
    updateBubble(count);
    if (wasEmpty !== (count === 0)) resetTimers();
  }

  function refresh() {
    var id = sectionId();
    return fetch(shopRoot + '?sections=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data[id]); })
      .catch(function (err) { console.error('[STDE cart] refresh failed', err); });
  }

  function showError(message) {
    var r = root();
    var el = r && r.querySelector('[data-stde-error]');
    if (!el || !message) return;
    el.textContent = message;
    el.hidden = false;
  }

  function emitUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  /* ---------------- Aantal wijzigen ---------------- */

  function changeQty(key, qty, itemEl) {
    if (busy) return;
    busy = true;
    if (itemEl) itemEl.classList.add('is-loading');

    var id = sectionId();
    fetch(URL_CHANGE, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: [id], sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          return refresh().then(function () { showError(r.data.description || r.data.message); });
        }
        render(r.data.sections && r.data.sections[id]);
        emitUpdated(r.data);
      })
      .catch(function (err) {
        console.error('[STDE cart] change failed', err);
        return refresh();
      })
      .then(function () { busy = false; });
  }

  /* ---------------- Toevoegen vanaf productformulier ---------------- */

  function isAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.hasAttribute('data-stde-ignore')) return false;
    var action = (form.getAttribute('action') || '').split('?')[0].split('#')[0];
    return /\/cart\/add(\.js)?\/?$/.test(action);
  }

  function formError(form, message) {
    var old = form.querySelector('.errors');
    if (old) old.remove();
    if (!message) return;
    var div = document.createElement('div');
    div.className = 'errors text-center';
    div.textContent = message;
    form.appendChild(div);
  }

  function addFromForm(form, submitter) {
    var btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('btn--loading'); btn.setAttribute('aria-disabled', 'true'); }

    var id = sectionId();
    var body = new FormData(form);
    body.append('sections', id);
    body.append('sections_url', window.location.pathname);

    fetch(URL_ADD, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          formError(form, r.data.description || r.data.message);
          return;
        }
        formError(form, null);
        if (r.data.sections && r.data.sections[id]) {
          render(r.data.sections[id]);
        } else {
          refresh();
        }
        open();
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: r.data, addToCartBtn: btn } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
      })
      .catch(function (err) {
        console.error('[STDE cart] add failed, falling back to normal submit', err);
        form.setAttribute('data-stde-ignore', '');
        form.submit();
      })
      .then(function () {
        if (btn) { btn.classList.remove('btn--loading'); btn.removeAttribute('aria-disabled'); }
      });
  }

  // Capture-fase: wij zijn eerst, zodat de theme/app-handlers niet dubbel toevoegen
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form) || onCartPage() || !root()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromForm(form, e.submitter);
  }, true);

  /* ---------------- Klikken ---------------- */

  document.addEventListener('click', function (e) {
    var r = root();
    if (!r) return;

    // Cart-icoon in de header
    var trigger = e.target.closest('.js-drawer-open-cart, [data-stde-cart-open]');
    if (trigger && !onCartPage()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      open();
      refresh();
      return;
    }

    if (!r.contains(e.target)) return;

    if (e.target.closest('[data-stde-close]')) {
      e.preventDefault();
      close();
      return;
    }

    var qtyBtn = e.target.closest('[data-stde-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var item = qtyBtn.closest('[data-key]');
      if (!item) return;
      var qty = Math.max(0, parseInt(qtyBtn.getAttribute('data-stde-qty'), 10) || 0);
      changeQty(item.getAttribute('data-key'), qty, item);
      return;
    }

    var checkout = e.target.closest('.stde-checkout');
    if (checkout) checkout.classList.add('is-loading');
  }, true);

  /* ---------------- Toetsenbord ---------------- */

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var panel = root().querySelector('.stde-cart__panel');
    var items = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  /* ---------------- Events van theme/andere scripts ---------------- */

  document.addEventListener('cart:open', function () { open(); refresh(); });
  document.addEventListener('stde-cart:open', function () { open(); refresh(); });
  document.addEventListener('cart:close', close);
  document.addEventListener('cart:build', refresh);
  document.addEventListener('stde-cart:refresh', refresh);

  // Terug via browser-back (bfcache): cart kan veranderd zijn
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  /* ---------------- Timer ---------------- */

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var TIMER_KEY = 'stde_cart_timer_start';

  function store(action, value) {
    try {
      if (action === 'get') return window.localStorage.getItem(TIMER_KEY);
      if (action === 'set') window.localStorage.setItem(TIMER_KEY, value);
      if (action === 'clear') window.localStorage.removeItem(TIMER_KEY);
    } catch (e) { /* storage geblokkeerd: timer start dan per pagina */ }
    return null;
  }

  function initTimers() {
    var r = root();
    if (!r) return;
    var cartEmpty = r.classList.contains('is-empty');

    r.querySelectorAll('[data-stde-timer]').forEach(function (el) {
      if (el._stdeTimer) clearInterval(el._stdeTimer);
      var bar = el.closest('[data-stde-bar]');
      var textEl = bar && bar.querySelector('[data-stde-bar-text]');
      if (textEl && !bar._stdeOriginal) bar._stdeOriginal = textEl.innerHTML;

      var mode = el.getAttribute('data-mode') || 'date';
      var end;

      if (mode === 'minutes') {
        if (cartEmpty) { store('clear'); el.textContent = ''; return; }
        var start = parseInt(store('get'), 10);
        if (!start) { start = Date.now(); store('set', String(start)); }
        end = start + (parseInt(el.getAttribute('data-minutes'), 10) || 15) * 60000;
      } else {
        end = Date.parse(el.getAttribute('data-end'));
      }

      if (isNaN(end)) { el.textContent = ''; return; }
      var dayLabel = el.getAttribute('data-day-label') || 'd';

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          clearInterval(el._stdeTimer);
          var expired = bar && bar.getAttribute('data-expired');
          if (expired && textEl) {
            textEl.textContent = expired;
          } else if (bar) {
            bar.hidden = true;
          }
          return;
        }
        var t = Math.floor(diff / 1000);
        var d = Math.floor(t / 86400);
        var h = Math.floor((t % 86400) / 3600);
        var m = Math.floor((t % 3600) / 60);
        var s = t % 60;
        if (mode === 'minutes') {
          el.textContent = pad(Math.floor(t / 60)) + ':' + pad(s);
        } else {
          el.textContent = (d > 0 ? d + dayLabel + ' ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        }
      }

      tick();
      el._stdeTimer = setInterval(tick, 1000);
    });
  }

  // Na elke cart-wijziging: minuten-timer starten/resetten, balk herstellen
  function resetTimers() {
    var r = root();
    var bar = r && r.querySelector('[data-stde-bar]');
    if (bar && bar._stdeOriginal) {
      bar.hidden = false;
      var textEl = bar.querySelector('[data-stde-bar-text]');
      if (textEl) textEl.innerHTML = bar._stdeOriginal;
    }
    initTimers();
  }

  initTimers();

  /* ---------------- Theme editor ---------------- */

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail.sectionId === sectionId()) { initTimers(); open(); }
    });
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail.sectionId === sectionId()) open();
    });
    document.addEventListener('shopify:block:select', function (e) {
      if (e.detail.sectionId === sectionId()) open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail.sectionId === sectionId()) close();
    });
  }

  if (window.theme && window.theme.settings && window.theme.settings.cartType === 'drawer') {
    console.warn('[STDE cart] Theme settings > Cart > "Cart type" staat op Drawer. Zet dit op Page om dubbele drawers te voorkomen.');
  }

  window.StdeCart = { open: open, close: close, refresh: refresh };
})();
